import { useEffect, useState } from "react";
import { CommonService } from "../../../../services/CommonService";

import Select from "../../../../components/Select";

export default function MaritalStautus({ searchObject, onChange, t }) {
  const [maritalStatusList, setMaritalStatusList] = useState([]);

  useEffect(() => {
    CommonService.getAllMaritalStatus().then((data) =>
      setMaritalStatusList(data)
    );
  }, []);

  return (
    <div>
      <legend className="fontsize-legend">{t("Marital Status")}</legend>
      <Select
        name="maritalStatusId"
        value={searchObject.maritalStatusId || ""}
        onChange={onChange}
        className="form-select fontsize-legend"
      >
        <option key={0} value="" selected></option>
        {maritalStatusList.map((maritalStatus) => (
          <option
            className="fontsize-legend"
            value={maritalStatus.id}
            key={maritalStatus.id}
          >
            {t(maritalStatus.description)}
          </option>
        ))}
      </Select>
    </div>
  );
}
